/* eslint-disable react/no-multi-comp,max-len */
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { toRoman } from 'helpers'

// SHV2-04-1
export const SORTIES_BY_VEHICLE_LEVEL_ON_PERIPHERY_OVERRIDDEN = (vehicleLevel, peripheryName, isDisabled) => {
    if (isDisabled) return (
        <FormattedMessage
            id='schedule.sortie_vl_server_disabled.tooltip'
            defaultMessage='Вылазки в {vehicleLevel} дивизионе на сервере {peripheryName} в этот день не проводятся.'
            values={{
                vehicleLevel: toRoman(vehicleLevel),
                peripheryName,
            }}
        />
    )
    return (
        <FormattedMessage
            id='schedule.sortie_vl_server_overridden.tooltip'
            defaultMessage='Вылазки в {vehicleLevel} дивизионе на сервере {peripheryName} в этот день проходят по изменённому расписанию.'
            values={{
                vehicleLevel: toRoman(vehicleLevel),
                peripheryName,
            }}
        />
    )
}


export const FORT_BATTLES_ON_PERIPHERY_OVERRIDDEN = (peripheryName, isDisabled) => {
    if (isDisabled) return (
        <FormattedMessage
            id='schedule.fort_battles_on_periphery_disabled.tooltip'
            defaultMessage='Наступления на сервере {peripheryName} в этот день не проводятся.'
            values={{ peripheryName }}
        />
    )
    return (
        <FormattedMessage
            id='schedule.fort_battles_on_periphery_overridden.tooltip'
            defaultMessage='Наступления на сервере {peripheryName} в этот день проходят по изменённому расписанию.'
            values={{ peripheryName }}
        />
    )
}


// WEBPACK FOOTER //
// ./containers/Schedule/components/ScheduleTable/tooltips/translations.js